import React, { Fragment } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import UsuarioComponent from './UsuarioComponent';

const Usuarios = () => {

  return (
    <Fragment>
      <Breadcrumbs parent="Cadastros" title="Usuários" mainTitle="Listagem de Usuários" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <UsuarioComponent />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );

};

export default Usuarios;